import React, { useState, useEffect, useRef } from 'react';

function NewCollection({ onCategorySelect }) {
  const sectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const fullTitle = 'Nuevas colecciones';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
        if (!entry.isIntersecting) {
          // Resetear cuando sale de vista
          setScrollProgress(0);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setScrollProgress(prev => {
        if (prev >= 1) {
          return 0; // Volver al inicio para loop continuo
        }
        return prev + 0.002; // Velocidad de desplazamiento
      });
    }, 30);

    return () => clearInterval(interval);
  }, [isVisible]);

  const collections = [
    {
      id: 1,
      title: 'Perfumes Premium',
      image: '/images/products/perfume.jpeg'
    },
    {
      id: 2,
      title: 'Fragancias Frescas',
      image: '/images/products/fragancia.jpeg'
    },
    {
      id: 3,
      title: 'Difusores',
      image: '/images/products/difusores.jpeg'
    },
    {
      id: 4,
      title: 'Aceites Aromáticos',
      image: '/images/products/aceitearomatico.jpeg'
    }
  ];

  const cardsTransform = `translateX(-${scrollProgress * 70}%)`;

  return (
    <section className="new-collection" ref={sectionRef}>
      <div className="collection-content">
        <div className="collection-left">
          <h2 className="collection-title">
            {fullTitle.split('').map((char, index) => (
              <span
                key={index}
                className="letter-fade-collection"
                style={{ animationDelay: `${3.5 + index * 0.08}s` }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </h2>
          <div className="collection-description">
            <p>
              Nuestra nueva colección está siendo desarrollada en colaboración con perfumistas franceses. Creamos nuestros productos usando ingredientes de la más alta calidad, incluyendo aceites esenciales puros y naturales para hacer nuestras fragancias únicas.
            </p>
            <p>
              Tenemos muchas opciones diferentes como perfumes, fragancias corporales y difusores para el hogar. No solo aromas, también ofrecemos velas aromáticas exclusivas. Es maravilloso poder llevar estos aromas únicos contigo a donde vayas.
            </p>
          </div>
        </div>

        <div className="collection-right">
          <div className="collection-cards" style={{ transform: cardsTransform }}>
            {collections.map((item, index) => (
              <div 
                key={item.id} 
                className="collection-card"
                style={{ animationDelay: `${4 + index * 0.2}s`, cursor: 'pointer' }}
                onClick={() => onCategorySelect && onCategorySelect(null)}
              >
                <div className="card-image">
                  <img src={item.image} alt={item.title} />
                  <div className="card-overlay">
                    <span className="overlay-text">Ver más</span>
                  </div>
                </div>
                <h3 className="card-title">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewCollection;
